import {
  SEASONAL_FACTOR_SUMMER,
  SEASONAL_FACTOR_WINTER,
} from "@/constants/finance"
interface IFormatMoney {
  amount: number
  showNegativeSign?: boolean
  showPositiveSign?: boolean
  round?: boolean
}

interface IFormatMoneySeasonal extends Partial<IFormatMoney> {
  divider?: string
  summerSeasonalAmount?: number
  winterSeasonalAmount?: number
  amount?: number
  seasonalAmounts?: {
    summer: number
    winter: number
  }
}

export function formatMoney({
  amount,
  showNegativeSign = true,
  showPositiveSign = false,
  round = false,
}: IFormatMoney) {
  let sign = ""
  const roundedAmount = round ? Math.round(amount) : amount
  const amountStr = Math.abs(roundedAmount)
    .toFixed(round ? 0 : 2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")

  if (showNegativeSign && roundedAmount < 0) {
    sign = "-"
  } else if (showPositiveSign && roundedAmount > 0) {
    sign = "+"
  }

  return sign + "£" + amountStr
}

export function formatSeasonalAmount({
  showNegativeSign = true,
  showPositiveSign = false,
  round = false,
  divider = "/",
  seasonalAmounts,
  amount,
}: IFormatMoneySeasonal): string {
  const summerAmount = formatMoney({
    amount:
      seasonalAmounts?.summer ||
      (amount && amount * SEASONAL_FACTOR_SUMMER) ||
      0,
    showNegativeSign: showNegativeSign,
    showPositiveSign: showPositiveSign,
    round: round,
  })
  const winterAmount = formatMoney({
    amount:
      seasonalAmounts?.winter ||
      (amount && amount * SEASONAL_FACTOR_WINTER) ||
      0,
    showNegativeSign: showNegativeSign,
    showPositiveSign: showPositiveSign,
    round: round,
  })
  return `${summerAmount} ${divider} ${winterAmount}`
}

export function formatBalance(amount: number) {
  const absoluteAmount = Math.abs(amount).toFixed(2)
  if (amount > 0) {
    return `£${absoluteAmount} Debit`
  } else if (amount < 0) {
    return `£${absoluteAmount} Credit`
  }
  return "£0"
}

export const formatPriceInPence = (
  amountInPence: number,
  fractionDigits = 2,
) => {
  const penceSymbol = "p"
  const amount = amountInPence.toFixed(fractionDigits)

  return `${amount} ${penceSymbol}`
}
